import * as t from 'io-ts';
import { AirportDynamicType } from './airport';

export const AirportsListDynamicType = t.array(AirportDynamicType);

export type AirportsList = t.TypeOf<typeof AirportsListDynamicType>;
